import moment from "moment";
let timeStemp = moment()
  .add(543, "years")
  .format("DD/MM/YYYY hh:mm:ss", true);
  
const waste_document = async function(data) {
  let DATA
  // console.log(typeof data);
  // console.log(data.length);
  if(data.length != 0){
    DATA = data[0]
  }else{
    DATA = data
  }


  
  
  let newCar_typew = "*",
    newWA = 0,
    newWB = 0,
    newWC = 0;

  DATA.CAR_TYPE = "1"
    ? (newCar_typew = "4 ล้อ")
    : (DATA.CAR_TYPE = "2" ? newCar_typew == "6 ล้อ" : (newCar_typew = "-"));
  DATA.TD1_WA != "-" ? (newWA += parseInt(DATA.TD1_WA)) : (newWA += 0);
  DATA.TD2_WA != "-" ? (newWA += parseInt(DATA.TD2_WA)) : (newWA += 0);
  DATA.TD3_WA != "-" ? (newWA += parseInt(DATA.TD3_WA)) : (newWA += 0);

  DATA.TD4_WB != "-" ? (newWB += parseInt(DATA.TD4_WB)) : (newWB += 0);
  DATA.TD5_WB != "-" ? (newWB += parseInt(DATA.TD5_WB)) : (newWB += 0);
  DATA.TD6_WB != "-" ? (newWB += parseInt(DATA.TD6_WB)) : (newWB += 0);
  DATA.TD7_WB != "-" ? (newWB += parseInt(DATA.TD7_WB)) : (newWB += 0);

  DATA.TD8_WC != "-" ? (newWC += parseInt(DATA.TD8_WC)) : (newWC += 0);

  const pdf = {
    //pageSize: 'A4',
    // pageMargins: [ 30, 0, 30, 0 ],
    footer(currentPage, pageCount) {
      return {
        columns: [
          // { text: "ท้ายกระดาษ", fontSize: 15, alignment: "center" },
          {
            text:
              "หน้าที่ " +
              currentPage.toString() +
              " จาก " +
              pageCount +
              " หน้า",
            margin: [5, 5, 15, 5],
            alignment: "right",
          },
        ],
      };
    },
    background: function() {
      return {
        canvas: [
          {
            type: "rect",
            x: 0,
            y: 0,
            w: 595.28,
            h: 841.89,
            color: "#00BFFF",
          },
        ],
      };
    },
    content: [
      // {
      //   columns: [
      //     {
      //       text: `เลขที่ :   ${timeStemp}    \n วันที่พิมพ์    ${timeStemp} น.`,
      //       fontSize: 16,
      //       alignment: "left",
      //       margin: [0, 50, 0, 0],//left top right bottom
      //     },
      //     {
      //       image: await getBase64ImageFromURL(
      //         "https://res.cloudinary.com/dfgnhewbg/image/upload/v1595224134/newchok-icon_tuzsem.png"
      //       ),
      //       alignment: "center",
      //       fit: [100, 100]
      //     },
      //     {
      //       qr: "text in QR",
      //       fit: 70,
      //       alignment: "right",
      //       margin: [0, 50, 30, 0],//left top right bottom
      //     },
      //   ],
      // },
      // {
      //   text: `เอกสาร ตช.`,
      //   style: `header`,
      // },
      {
        columns: [
          {
            text: `เลขที่ :   ${DATA.T_ID}    \n วันที่พิมพ์    ${timeStemp} น.`,
            fontSize: 16,
            alignment: "left",
            // margin: [0, 0, 0, 0],//left top right bottom
          },
          {
            text: `เอกสาร ตช.`,
            fontSize: 16,
            bold: true,
            style: `header`,
            margin: [0, 10, 0, 0],
          },
          {
            qr: "text in QR",
            fit: 60,
            alignment: "right",
            margin: [0, 0, 30, 0], //left top right bottom
          },
        ],
      },

      {
        columns: [
          {
            text: `ชื่อเอกชน/ผู้เก็บขน ที่อยู่     ${this.$AppName.partnership}`,
            fontSize: 16,
            style: `content`,
          },

          {
            text: `โทรศัพท์     0816949845`,
            fontSize: 16,
            style: `content`,
            width: 200,
          },
        ],
      },
      {
        columns: [
          {
            text: `รถขนมูลฝอย     ${newCar_typew}`,
            fontSize: 16,
            style: `content`,
          },
          {
            text: `เลขทะเบียน     ${DATA.CAR_NUMBER}`,
            fontSize: 16,
            style: `content`,
            width: 200,
          },
        ],
      },
      {
        columns: [
          {
            text: `ชื่อคนขับรถ     ${DATA.PD_NAME} ${DATA.PD_LAST}`,
            fontSize: 16,
            style: `content`,
          },
          {
            text: `โทรศัพท์     ${DATA.PD_PHONE}`,
            fontSize: 16,
            style: `content`,
            width: 200,
          },
        ],
      },
      {
        columns: [
          {
            text: `ชื่อพนักงานเก็บขน     ${DATA.PC_NAME} ${DATA.PC_LAST}`,
            fontSize: 16,
            style: `content`,
          },
          {
            text: `โทรศัพท์     ${DATA.PC_PHONE}`,
            fontSize: 16,
            style: `content`,
            width: 200,
          },
        ],
        margin: [0, 0, 0, 10], //left top right bottom
      },
      // {
      //   text: `ชื่อเอกชน/ผู้เก็บขน ที่อยู่ _________________ โทรศัพท์ _________________ \n รถขนมูลฝอย _________________  เลขทะเบียน _________________ \n ชื่อคนขับรถ _________________  โทรศัพท์ _________________ \n ชื่อพนักงานเก็บขน ________________ โทรศัพท์ ________________ \n `,
      //   style: `content`,
      // },

      {
        table: {
          headerRows: 1,
          widths: ["*", 100, 100, 100],
          bodyRows: 2,
          body: [
            [
              {
                text: "แหล่งกำเนิดมูลฝอยติดเชื้อ",
                bold: true,
                fontSize: 16,
                alignment: "center",
              },
              {
                text: "เวลาเข้าเก็บ",
                fontSize: 16,
                bold: true,
                alignment: "center",
              },
              {
                text: "เวลาออก",
                fontSize: 16,
                bold: true,
                alignment: "center",
              },
              {
                text: "ลายเซ็นโรงกำจัด",
                fontSize: 16,
                bold: true,
                alignment: "center",
              },
            ],
            [
              {
                text: DATA.C_N,
                fontSize: 16,
                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_I} น.`,
                fontSize: 16,
                alignment: "center",
                justify: "center",
              },
              {
                text: `${DATA.W_O} น.`,
                fontSize: 16,
                alignment: "center",
                justify: "center",
              },
              {
                image: await getBase64ImageFromURL(
                  "https://res.cloudinary.com/dfgnhewbg/image/upload/v1595224134/newchok-icon_tuzsem.png"
                ),
                alignment: "center",
                fit: [50, 50],
                justify: "center",
              },
            ],
          ],
        },
      },
      {
        text: ``,
        margin: [0, 15, 0, 0], //left top right bottom
      },
      {
        table: {
          // headers are automatically repeated if the table spans over multiple pages
          // you can declare how many rows should be treated as headers
          headerRows: 1,
          widths: [100, 100, 100, "*"],

          body: [
            [
              {
                text: "ขยะเคมี (กก.)",
                bold: true,
                fontSize: 16,
                alignment: "center",
              },
              {
                text: "ขยะติดเชื้อ (กก.)",
                fontSize: 16,
                bold: true,
                alignment: "center",
              },
              {
                text: "ขยะอันตราย (กก.)",
                fontSize: 16,
                bold: true,
                alignment: "center",
              },
              {
                text: "ปริมาณมูลฝอย (กก.)",
                fontSize: 16,
                bold: true,
                alignment: "center",
              },
            ],
            [
              {
                text: newWA,
                fontSize: 16,
                alignment: "center",
                justify: "center",
              },
              {
                text: newWB,
                fontSize: 16,
                alignment: "center",
                justify: "center",
              },
              {
                text: newWC,
                fontSize: 16,
                alignment: "center",
                justify: "center",
              },
              {
                text: DATA.W_W,
                fontSize: 16,
                alignment: "center",
                justify: "center",
              },
            ],
          ],
        },
      },

      {
        text: `ชื่อ จนท.รพ. ผู้ส่งมอบมูลฝอย     ${DATA.P_N}`,
        style: `content`,
        fontSize: 16,
        margin: [15, 15, 0, 0], //left top right bottom
      },
      {
        text: `______________________________________________________________________________________`,
        style: `content`,
        fontSize: 16,
        margin: [0, 0, 0, 0], //left top right bottom
      },
      {
        columns: [
          {
            text: `สถานที่กำจัด      ${DATA.D_N}`,
            style: `content`,
            fontSize: 16,
          },
          {
            text: `โทรศัพท์      ${DATA.D_P}`,
            style: `content`,
            fontSize: 16,
            width: 200,
          },
        ],
      },
      {
        columns: [
          {
            text: `ที่อยู่      ${DATA.D_A}`,
            style: `content`,
            fontSize: 16,
          },
        ],
      },
      {
        columns: [
          {
            text: `ชื่อเจ้าหน้าที่โรงกำจัด      ${DATA.D_O}`,
            style: `content`,
            fontSize: 16,
          },
          {
            text: `โทรศัพท์      ${DATA.D_O_P}`,
            style: `content`,
            fontSize: 16,
            width: 200,
          },
        ],
      },
      {
        columns: [
          {
            text: `ปริมาณกำจัดมูลฝอยสุทธิ      ${DATA.D_W} กก.`,
            style: `content`,
            fontSize: 16,
          },
          {
            text: `ว.ด.ป ที่รับมอบ      ${DATA.D_D} น.`,
            style: `content`,
            fontSize: 16,
            width: 200,
          },
        ],
      },
      // {
      //   text: `สถานที่กำจัด __________________________________  โทรศัพท์ _______________ \n ที่อยู่ __________________________________  \n ชื่อเจ้าหน้าที่โรงกำจัด __________________________________  โทรศัพท์ _______________ \n ปริมาณกำจัดมูลฝอยสุทธิ __________________________________  ว.ด.ป ที่รับมอบ _______________ `,
      //   style: `content`,
      // },
      {
        text: `______________________________________________________________________________________`,
        style: `content`,
        margin: [0, 5, 0, 0], //left top right bottom
      },
    ],
    defaultStyle: {
      font: "THSarabunNew",
    },
    styles: {
      header: {
        fontSize: 18,
        alignment: "center",
        //bold: true
      },
      content: {
        fontSize: 16,
        alignment: "left",
        margin: [0, 10, 0, 0],
      },
      content_8: {
        fontSize: 16,
        alignment: "left",
        margin: [20, 10, 0, 0],
      },
      signature: {
        fontSize: 16,
        alignment: "center",
        margin: [0, 30, 0, 0],
      },
    },
  };
  return pdf;
};

function getBase64ImageFromURL(url) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL("image/png");

      resolve(dataURL);
    };

    img.onerror = (error) => {
      reject(error);
    };

    img.src = url;
  });
}

export default waste_document;
